































































































































































import Vue from "vue";
import BackLink from "@/components/app/BackLink.vue";
import { ChargesVue } from "fs-pb-vue2/vueModels/charges/ChargesVue";
import i18n from "@/i18n";
import { Component } from "vue-property-decorator";
import { OperationRequestData } from "fs-pb-vue2/data/operationRequestData";
import { DeclarationPropertiesTypes } from "fs-pb-vue2/data/enums/declarationPropertiesTypes";
import { OperationsApi } from "fs-pb-vue2/services/api/OperationsApi";
import { getLocalInitDataId } from "fs-pb-vue2/utilities/index";

@Component({
  components: { BackLink }
})
export default class Charges extends ChargesVue {

  catImages: any[] = [];
  
  async toC2GPayment(): Promise<void> {
    try {
      this.execLoading = true;
      if (this.configStore.apiData.OperationCodeOfSbpC2GOperation === "") {
        throw new Error('Операция не доступна, попробуйте позже');
      }
      const ord: OperationRequestData = new OperationRequestData();
      ord.respondentCode =
        this.configStore.apiData.OperationCodeOfFillOperationFromCharge;
      ord.setProperty(
        "charge",
        this.selectedCharge.Data,
        DeclarationPropertiesTypes.String
      );
      const resp: any = await OperationsApi.operationSendAsync('WebClient/FillList', ord);

      const addInitData: Array<string> = [];

      if (resp.data && resp.data.Data && resp.data.Data.Properties) {
        
        for (const key in resp.data.Data.Properties) {
          const item: any = resp.data.Data.Properties[key];
          if (key == "codedoc") {
            addInitData.push(`uin=${item}`);
          }
        }
        addInitData.push(`docCategory=${this.selectedCharge.Subscription.Document.Type.Category}`);
      }
      const addId: string = getLocalInitDataId(addInitData.join("&"));

      this.$router.push(
        `/operation/0/${
          this.configStore.apiData.OperationCodeOfSbpC2GOperation
        }?initDataId=${addId}`
      );

      this.execLoading = false;
    } catch (e: any) {
      this.alertService.error(e.message);
      this.execLoading = false;
    }
  }

  async mounted() {
    if (!this.configStore.apiData.ChargesEnable) {
      this.$router.go(-1);
    }
    if (this.catImages.length === 0) {
      await this.getCategorysImages();
    }
    await this.init();
  }

  getCategoryImage(category: string): string | undefined {
    const categoryImage = this.catImages.find(cat => cat.category === category);
    return categoryImage ? categoryImage.image : undefined;
  }

  get isMobileBrowser(): boolean {
    const userAgent = navigator.userAgent;
    const mobileRegExp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
    return mobileRegExp.test(userAgent);
  }
}
